import { CommunitySelectorResultDto } from '../../../_models/community-selector-result-dto';

export class UserCommunityCoordinatesResultDto {
    communityId: number;
    communityName: string;
    latitude: number;
    longitude: number;

    // Transient
    communityInfo: CommunitySelectorResultDto;
}
